import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// R5.1: no analytics backend exists yet (checked template.yaml/package.json/deploy workflows --
// nothing), so this is an honest interim step, not real monitoring -- logs each Core Web Vitals
// metric in production only, so dev/test runs stay silent. Revisit once a real destination exists.
reportWebVitals(
  process.env.NODE_ENV === 'production'
    ? metric => console.info('[web-vitals]', metric)
    : undefined
);
